<template>
    <masked-input
        type="text"
        name="phone"
        v-model="localValue"
        :show-mask="true"
        :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]">
    </masked-input>
</template>

<script>
    import MaskedInput from 'vue-text-mask'

    export default {
        name: 'PhoneNumber',

        props: {
            value: {
                type:     [String, Number],
                required: false,
                default:  ''
            }
        },

        data() {
            return {
                localValue: `${this.value}`
            }
        },

        watch: {
            value(newValue) {
                this.localValue = `${newValue}`
            },

            localValue(newValue) {
                let parsedValue = (newValue + '').replace(/\D/g, '')
                this.$emit('input', Number(parsedValue));
            }
        },

        components: {
            MaskedInput
        }
    }
</script>
